<div *ngIf="!configMode" class="non-config-mode-container">
    <p *ngIf="eventNotAvailable" class="the-event-is-no-longer-available">
        <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
    </p>
    <azavista3-apexcharts-wrapper *ngIf="series" #displayModeChart [series]="series" [labels]="labels"
        [type]="chart.type" [width]="chart.width" [height]="chart.height"
        (dataPointSelected)="onDataPointSelected($event)">
    </azavista3-apexcharts-wrapper>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <div class="aza-pa-flex-row event-selection">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
        <div class="setting-item">
            <azavista-input-field
                (valueChanged)="onSettingsLocalUpdate('chartType', $event.value)"
                [field]="settingsLocalFields.chartType"
                [value]="definitionSettings?.local?.chartType"
                [editMode]="true"
            ></azavista-input-field>
        </div>
        <ng-container *ngIf="settingsRemoteFields">
            <div class="setting-item">
                <azavista-input-field
                    (valueChanged)="onSettingsRemoteUpdate('email_campaign_id', $event.value)"
                    [field]="settingsRemoteFields.email_campaign_id"
                    [value]="definitionSettings?.remote.email_campaign_id"
                    [editMode]="true"
                ></azavista-input-field>
            </div>
            <div class="setting-item">
                <azavista-input-field
                    (valueChanged)="onSettingsRemoteUpdate('email_statuses', $event.value)"
                    [field]="settingsRemoteFields.email_statuses"
                    [value]="definitionSettings?.remote?.email_statuses"
                    [editMode]="true"
                ></azavista-input-field>
            </div>
        </ng-container>
    </div>
</div>
